<mat-toolbar class="matero-toolbar">
  <button mat-icon-button class="matero-toolbar-button" *ngIf="!environment.collapsibleSidebar || isMobile"
          (click)="toggleSidenav.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <span *ngIf="!isMobile" class="flex-1 pl-4 flex-row" style="color: #005595">ORELAP Administration</span>
  <span *ngIf="isMobile" class="flex-1" style="color: #005595">ORELAP</span>

  <button mat-icon-button
          *ngIf="!authenticated()"
          routerLink="/login"
          matTooltip="Login"
          matTooltipPosition="below"
          [matTooltipShowDelay]="750">
    <mat-icon [ngClass]="darkMode? 'dark-theme-icon' : ''">account_circle</mat-icon>
  </button>

  <div *ngIf="authenticated()" class="flex flex-row gap-4 justify-center items-center">
    <span routerLink="/update-user" style="cursor: pointer">Hello, {{getUserName()}}</span>

    <!-- 
    <button mat-icon-button
            matTooltip="Logout"
            (click)="logout()"
            matTooltipPosition="below"
            [matTooltipShowDelay]="750">
      <mat-icon [ngClass]="darkMode? 'dark-theme-icon' : ''">exit_to_app</mat-icon>
    </button> 
    -->
  </div>

  <app-translate *ngIf="environment.translateText"></app-translate>

  <button mat-icon-button
          *ngIf="environment.showThemeToggle && darkMode"
          class="matero-toolbar-button"
          (click)="toggleTheme()"
          aria-label="Toggle Theme"
          matTooltip="Select Light Theme"
          matTooltipPosition="below"
          [matTooltipShowDelay]="750">
    <mat-icon class="light-theme-icon">brightness_7</mat-icon>
  </button>

  <button mat-icon-button
          *ngIf="environment.showThemeToggle && !darkMode"
          class="matero-toolbar-button"
          (click)="toggleTheme()"
          aria-label="Toggle Theme"
          matTooltip="Select Dark Theme"
          matTooltipPosition="below"
          [matTooltipShowDelay]="750">
    <mat-icon class="dark-theme-icon">brightness_3</mat-icon>
  </button>

</mat-toolbar>
